<div class="dropdown">
  <a
    class="nav-link dropdown-toggle lang-toggle d-flex align-items-center"
    href="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {{ activeLocale | uppercase }}
  </a>
  <ul class="dropdown-menu dropdown-menu-end">
    @for (locale of locales; track locale.code) {
      <li>
        <a
          class="dropdown-item"
          [class.active]="activeLocale == locale.code"
          [routerLink]=""
          (click)="setLanguage(locale.code)"
        >
          {{ locale.name }}
        </a>
      </li>
    }
  </ul>
</div>
